export enum StoreLocatorTabs {
  LIST_VIEW = 'listView',
  MAP_VIEW = 'mapView',
}
